/*eslint-disable*/
import { useEffect, useState } from "react";
import axios from "axios";
import axiosInstance from "../../../utils/axiosInstance";

const GetToken = () => {
  return localStorage.getItem("JWT");
};

export default function useBookSearch(query, pageNumber, loadingData) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [books, setBooks] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setBooks([]);
  }, [query]);

  useEffect(() => {
    setLoading(true);
    setError(false);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    var params = new URLSearchParams();
    params.append("limit", 8);
    params.append("page", pageNumber);
    params.append("trabajadores_id", query.TrabajadoresId);

    axiosInstance()
      .get("/api/v1/rules/incidencia", { params, cancelToken: source.token })
      .then((res) => {
        // console.log(res.data.data);
        setBooks((prevBooks) => {
          return [...new Set([...prevBooks, ...res.data.data.Results])];
        });
        setHasMore(res.data.data.Results.length > 0);
        setLoading(false);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;
        setError(true);
      });
    return () => source.cancel();
  }, [query, pageNumber, loadingData]);

  return { loading, error, books, hasMore };
}
